import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import LogoKA from "../../assets/logo/logo-krause-assistencial-branco.png";
import LogoKrause from "../../assets/logo/logo-grupo-krause-branco.png";
import "./Header.css";

export default function Header() {
  return (
    <Container className="header-container">
      <img src={LogoKA} alt="Logo Krause" className="header-logo" />
      <Navbar collapseOnSelect expand="lg">
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="header-nav-links">
            <Nav.Link href="#como-funciona">COMO FUNCIONA</Nav.Link>
            <Nav.Link href="#premios">PRÊMIOS</Nav.Link>
            <Nav.Link href="#ganhadores">GANHADORES</Nav.Link>
            <Nav.Link href="#duvidas">DÚVIDAS</Nav.Link>
            <Nav.Link href="#regulamento">REGULAMENTO</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <img src={LogoKrause} alt="Logo Krause" className="header-logo" />
    </Container>
  );
}
